// State
export const state = {
  IS_LOADING: 'isLoading',
  COLLECTION: 'collection',
  COLLECTION_SUMMARIES: 'collectionSummaries',
  FIRST_VISITS: 'firstVisits',
  LAST_VISITS: 'lastVisits',
  VISIT_VARIABLE: 'visitVariable',
  TIMES_BETWEEN_VISITS: 'timesBetweenVisits',
  TIMES_BETWEEN_VISITS_REQUEST_NUM: 'timesBetweenVisitsRequestNum',
  TIMES_BETWEEN_VISITS_REQUEST_DELAY_SECS: 'timesBetweenVisitsRequestDelaySecs',
  NUM_SELECTED_SUBJECTS: 'numSelectedSubjects',
};

// Mutations
export const mutations = {
  SET_COLLECTION: 'setCollection',
  SET_COLLECTION_SUMMARIES: 'setCollectionSummaries',
  SET_LOADING: 'setLoading',
  SET_FIRST_VISITS: 'setFirstVisits',
  SET_LAST_VISITS: 'setLastVisits',
  SET_VISIT_VARIABLE: 'setVisitVariable',
  SET_TIMES_BETWEEN_VISITS: 'setTimesBetweenVisits',
  INCREMENT_TIMES_BETWEEN_VISITS_REQUEST_NUM:
    'incrementTimesBetweenVisitsRequestNum',
  SET_NUM_SELECTED_SUBJECTS: 'setNumSelectedSubjects',
};

// Actions
export const actions = {
  FETCH_COLLECTION: 'fetchCollection',
  FETCH_COLLECTION_SUMMARIES: 'fetchCollectionSummaries',
  SET_FIRST_VISITS: 'setFirstVisits',
  SET_LAST_VISITS: 'setLastVisits',
  SET_FIRST_VISIT: 'setFirstVisit',
  SET_LAST_VISIT: 'setLastVisit',
  SET_VISIT_VARIABLE: 'setVisitVariable',
  FETCH_TIMES_BETWEEN_VISITS: 'fetchTimesBetweenVisits',
  SAVE_FIRST_AND_LAST_VISITS: 'saveFirstAndLastVisits',
};
